import React from 'react';
import { ArrowLeft, Edit2, Save, X, ShoppingBag } from 'lucide-react';
import { Button } from '../../SubscriptionAppButton';
import { Badge } from '../../SubscriptionAppBadge';
import { getStatusVariant } from '../../../data/mockSubscriptionData';
export interface SubscriptionHeaderProps {
  subscription: any;
  isEditing: boolean;
  onEdit: () => void;
  onSave: () => void;
  onCancel: () => void;
  onBack: () => void;
  onCreateOneTimeOrder?: () => void;
  isSaveDisabled?: boolean;
  hasChanges?: boolean;
}
export function SubscriptionHeader({
  subscription,
  isEditing,
  onEdit,
  onSave,
  onCancel,
  onBack,
  onCreateOneTimeOrder,
  isSaveDisabled = false,
  hasChanges = false
}: SubscriptionHeaderProps) {
  if (!subscription) return null;
  return <div className="mb-6" data-id="element-5448" data-mp="xeb1so93d1ci">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-5449" data-mp="1l5q80s3zo2t1">
        <div className="flex items-center gap-4" data-id="element-5450" data-mp="1pwoq9x8jfayx">
          <button onClick={onBack} className="flex items-center justify-center w-10 h-10 rounded-md border border-[#CBD5E1] bg-white hover:bg-[#F8FAFC] transition-colors" data-id="element-5451" data-mp="1pyj9n745uv0w">
            <ArrowLeft className="w-5 h-5 text-[#475569]" data-id="element-5452" data-mp="1owy3lrdkxo8o" />
          </button>
          <div data-id="element-5453" data-mp="22nbbjtqh12y0">
            <div className="flex items-center gap-3 mb-1" data-id="element-5454" data-mp="22ntbb0ccdzao">
              <h1 className="text-2xl font-semibold text-[#0F172A]" data-id="element-5455" data-mp="22pebb5hfeafx">
                {subscription.id}
              </h1>
              {!isEditing && <Badge variant={getStatusVariant(subscription.status)} data-id="element-5456" data-mp="2cky1db9b6ewr">
                  {subscription.status}
                </Badge>}
            </div>
            <p className="text-sm text-[#64748B]" data-id="element-5457" data-mp="27oqxdo0h3dhg">
              {subscription.customerName} | {subscription.customer}
            </p>
          </div>
        </div>

        <div className="flex items-center gap-3" data-id="element-5458" data-mp="2hm5b3fv0ho62">
          {isEditing ? <>
              <Button variant="outline" onClick={onCancel} iconLeft={<X size={16} data-id="element-5460" data-mp="ra7qfrdimjuy" />} data-id="element-5459" data-mp="r7mn0xxkjvv3">
                Cancel
              </Button>
              <Button variant="primary" onClick={onSave} iconLeft={<Save size={16} data-id="element-5462" data-mp="2mc2qfrfah2d8" />} disabled={!hasChanges} data-id="element-5461" data-mp="n8dvlzq04a2p">
                Save Changes
              </Button>
            </> : <>
              {onCreateOneTimeOrder && <Button variant="outline" onClick={onCreateOneTimeOrder} iconLeft={<ShoppingBag size={16} data-id="element-5464" data-mp="2w8p8k8g8dfbk" />} data-id="element-5463" data-mp="2raw3jiqnyrcv">
                  Create one-time order
                </Button>}
              <Button variant="primary" onClick={onEdit} iconLeft={<Edit2 size={16} data-id="element-5466" data-mp="35af4nrl252fo" />} data-id="element-5465" data-mp="319lcgm0l11gz">
                Edit
              </Button>
            </>}
        </div>
      </div>
    </div>;
}